import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getCurrencyList(project_uid){
  return request({
    url: `/api/projects/currency/list/${project_uid}`,
    method: "get"
  });
}

export function getCurrencyActive(project_uid){
  return request({
    url: `/api/projects/currency/active/${project_uid}`,
    method: "get"
  });
}

export function addCurrency(project_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/projects/currency/add/${project_uid}`,
    method: "post",
    data: data
  });
}

export function getCurrency(currency_uid){
  return request({
    url: `/api/projects/currency/${currency_uid}`,
    method: "get"
  });
}

export function updateCurrency(currency_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/projects/currency/${currency_uid}`,
    method: "put",
    data: data
  });
}